import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { TestEventResults } from "@/api/williams/testEvents";
import { useQuery } from "react-query";

export function useTestResults(eventId?: string) {
  const id = eventId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.testEvent.results(id),
    queryFn: () => api.getTestEventResults(id),
    select: (results) => {
      return transform(results);
    },
  });
}

export function transform(results: TestEventResults) {
  for (const welder of results.welders) {
    for (const template of welder.templates) {
      for (const segment of template.segments) {
        // Remove time portion so it works with the HTML date input.
        segment.testDate = segment.testDate?.substring(0, 10);
      }
    }
  }
  return results;
}
